import {Avatar, Button, Grid} from '@material-ui/core'
import Styled from '../../components/Styled'
import styles from './styles'
import H3 from 'src/components/Typography/H3'
import Subtitle2 from 'src/components/Typography/Subtitle2'

export const RootGrid = Styled(Grid, styles.rootGrid)
export const Title = Styled(H3, styles.title)
export const Text = Styled(Subtitle2, styles.text)
export const AppstoreButton = Styled(Button, styles.appstoreButton)
export const AppstoreImage = Styled(Avatar, styles.appstoreImage)
